<template>
  <v-card class="mt-5 gray10">
    <v-tabs background-color="transparent" v-model="tab" class="mt-3">
      <v-tab
        ><span class="font-Medium-14"
          >{{ $t("exchange.excoinoMarketChart") }}
        </span></v-tab
      >
      <template v-if="currentCoin">
        <v-tab v-if="currentCoin.baseSymbol !== 'IRR'">
          <span class="font-Medium-14">{{ $t("exchange.globalChart") }}</span>
        </v-tab>
      </template>
      <v-tab
        ><span class="font-Medium-14">{{ $t("exchange.depth") }}</span></v-tab
      >
      <div class="button-controls" v-if="currentCoin && tab === 0 && isAuth">
        <v-btn
          color="primary"
          @click="setIndicators"
          class="btn btn-secondary elevation-0 mt-4 me-4 save-chart-btn"
        >
          <v-icon v-if="$vuetify.breakpoint.smAndDown" clr="var(--v-gray2-base)"
            >$floppySave</v-icon
          >
          <span v-else>{{ $t("exchange.saveChart") }}</span>
        </v-btn>
      </div>
    </v-tabs>
    <v-row class="mb-2 charts-wrapper pa-4">
      <v-col cols="12" class="local-tradingview">
        <localTradingView
          v-if="currentCoin && tab === 0"
          :key="currentCoin.symbol"
          :currentCoin="currentCoin"
          ref="localTradingView"
        >
        </localTradingView>
        <global-trading-view
          v-if="currentCoin && currentCoin.baseSymbol !== 'IRR' && tab === 1"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
        />
        <depth-graph
          v-if="
            currentCoin && tab === (currentCoin.baseSymbol !== 'IRR' ? 2 : 1)
          "
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import localTradingView from "@/components/Market/exchange/tradeCharts/localTradingView.vue";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import GlobalTradingView from "@/components/Market/exchange/tradeCharts/globalTradingView.vue";
import DepthGraph from "@/components/Market/exchange/tradeCharts/depthGraph.vue";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "index",
  mixins: [authMixin],
  components: {
    DepthGraph,
    GlobalTradingView,
    localTradingView
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    })
  },
  data() {
    return {
      tab: 0
    };
  },
  methods: {
    setIndicators() {
      this.$refs.localTradingView.setIndicators();
    }
  }
};
</script>
<style lang="scss">
.charts-wrapper {
  min-height: 300px;
  background: var(--v-gray1) !important;
  height: 100%;

  .chart-loader {
    position: absolute;
    left: 50%;
  }
}

.local-tradingview {
  height: 350px;
  position: relative;
  overflow: hidden;

  #chart_wrapper {
    height: 100%;

    #tv_chart_container {
      height: 100%;

      iframe {
        height: 100% !important;
      }
    }
  }

  .local-tradingview-in {
    position: absolute;
    top: 5px;
    right: 40px;
    z-index: 1;

    .local-tradingview-in-btn {
      border-radius: 0 !important;
    }
  }
}

.global-tradingview {
  height: 100%;
  position: relative;
  overflow: hidden;

  .tradingview-widget-container {
    height: 100%;

    .trading-view-in {
      height: 100%;
    }
  }

  .local-tradingview-in {
    position: absolute;
    top: 5px;
    right: 40px;
    z-index: 1;

    .local-tradingview-in-btn {
      border-radius: 0 !important;
    }
  }
}

.trade_wrap {
  position: relative;

  .trade_menu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #27313e;
    height: 40px;
    line-height: 39px;

    @media (max-width: 700px) {
      height: 50px;
      overflow-x: auto;
    }

    > span {
      min-width: 140px;
      cursor: pointer;

      &.active {
        background-color: #27313e;
        border-bottom: 1px solid #f0a70a;
      }

      @media (max-width: 576px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .info-modal-button {
      display: flex;
      cursor: pointer;
    }
  }

  .trade-type {
    display: none;
    justify-content: center;
    align-items: center;

    .trade-type-buy,
    .trade-type-sell {
      position: relative;
      width: 50%;
      height: 30px;
      line-height: 30px;
    }

    .trade-type-sell {
      background-color: #f15050;
      cursor: pointer;

      &:hover {
        background-color: #f1505f;

        &:after {
          border-right: 15px solid #f1505f;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
        }
      }

      &:after {
        position: absolute;
        content: "";
        border-right: 15px solid #f1505f;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        top: 0;
        left: -14px;
        z-index: 2;
      }
    }

    .trade-type-buy {
      background-color: #00b270;
      cursor: pointer;
      z-index: 1;

      &:hover {
        background-color: #00b27f;
      }
    }
  }

  .mask {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 110;
    color: #ffffff;
  }

  .publish-mask {
    position: absolute;
    height: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 109;
  }
}

.change-tradingview-chart {
  min-width: 120px;
  border-radius: 0;
}

@media (max-width: 800px) {
  .trade_wrap {
    .trade-type {
      display: flex !important;
    }
  }
}

@media (max-width: 576px) {
  .exchange {
    .trade_wrap .trade_menu {
      & > span {
        @media (min-width: 576px) {
          min-width: 33.33333%;
        }
      }
    }
  }
}

#kline_container {
  background: var(--v-gray1);
}
.save-chart-btn {
  position: absolute;
  left: 0;
  top: -16px;
}
</style>
